import React from "react";

export interface ColumnAttribute {
    text: string;
    icon: any;
}

export const TableColumns = [
    { text: "", icon: <></> }, // Empty header for expand/collapse icon
    { text: "Số tài khoản", icon: <></> },
    { text: "Tên tài khoản", icon: <></> },
    { text: "Tính chất", icon: <></> },
    { text: "Tên tiếng Anh", icon: <></> },
    { text: "Diễn giải", icon: <></> },
    { text: "Trạng thái", icon: <></> },
    { text: "Chức năng", icon: <></> },
];

export const TitleBar = {
    title: "Tài khoản kế toán",
    addButtonText: "Thêm tài khoản kế toán",
};

export const CreateAccountingAccountTitleBar = {
    title: "Tạo mới tài khoản kế toán",
    addButton: "Tạo mới",
    cancelButton: "Hủy bỏ",
};

export const Search = {
    searchText: "Tìm kiếm theo từ khóa Số tài khoản, Tên tài khoản",
};
